import { queryOptions } from "@tanstack/react-query";
import { projectKeys } from "$/modules/projects/lib/queries";
import { getAllQuestionnairesByProjectId } from "./questionnaire";

export const questionnairesQueryOptions = (userId: string, projectId: string) =>
	queryOptions({
		queryKey: [...projectKeys.project(userId, projectId), "questionnaires"],
		queryFn: () => getAllQuestionnairesByProjectId({ projectId }),
	});
